import { CarbonFilter } from '../../characteristic-consult/interfaces/carbon-filter';
import { countActiveFilters } from '../../characteristic-consult/shared/characteristic-consult.utils';

export function countRegisterConfirmationFilters(
  drawerFilters: CarbonFilter,
  toolbarCarbonCreditCode: string,
): number {
  const toolbarCode = toolbarCarbonCreditCode.trim();

  return countActiveFilters({
    ...drawerFilters,
    carbonCreditCode: toolbarCode || drawerFilters.carbonCreditCode || undefined,
  });
}
